<template>
    <div class="investment_warp">
      <SearchHunt
        :filterData="filterData"
        @handle_seach="handle_seach"
        @handle_add="handle_add"
        @handle_upload="handle_upload"
        ref="SearchHunt"
      />
      <a-table
        class="antd-table"
        bordered
        :columns="relevanceBatch_grid.field"
        :data-source="relevanceBatch_grid.row"
        rowKey="id"
        size="small"
        :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
        :pagination="false"
        :loading="tableLoading"
      >
        <!-- 序号 -->
        <span slot="index" slot-scope="text, record, index">
          {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
        </span>
        <!-- 病例档案 -->
        <span slot="rechargeAmount" slot-scope="text, record" class="ellipsis">
          <a @click="look(record)">查看</a>
        </span>
        <!-- 更多操作 -->
        <span slot="operation" slot-scope="data" class="ellipsis">
          <a @click="handle_update(data)">编辑</a>
          <a @click="handle_detele(data.id)">删除</a>
        </span>
      </a-table>
  
      <!-- 底部 -->
      <div class="table_bottom">
  
        <!-- 分页 -->
        <div>
          <a-pagination
            class="table_pagination"
            show-size-changer
            :default-current="1"
            v-model="pageParam.pageNum"
            :show-total="(total) => `共 ${total} 条`"
            :page-size-options="pageSizeOptions"
            size="small"
            :total="total"
            @showSizeChange="onShowSizeChange"
            @change="paginationChange"
            :page-size.sync="pageParam.pageSize"
          />
        </div>
      </div>
  
      <!-- 表单 -->
      <!-- 添加 -->
      <addModal
        v-if="addVisible"
        :modalTitle="addTitle"
        :data="addData"
        :memberId="memberId"
        @close="close" 
        @handleOk="addlHandleOk"
      ></addModal>

      <!-- 批量导入 -->
      <excelModal
        v-if="excelVisible"
        :modalTitle="excelTitle"
        @close="close" 
        @handleOk="excelHandleOk"
      ></excelModal>

    </div>
  </template>
  
  <script>
  import {
    addCompany,
    deleteByIdCompany,
    undateMember,
    queryMemberInfo,
    queryMemberList,
    addMember,
    deleteMember
  } from "@/api/api.js";
  import SearchHunt from "./components/search-hunt/search-hunt.vue";
  import addModal from "./components/modal-hunt/add-modal.vue";
  import excelModal from "./components/search-hunt/modal.vue";
  import { DictionaryService } from "@common/services/dictionary.service";
  export default {
    name: "",
    components: {
      SearchHunt,
      addModal,
      excelModal
    },
    data() {
      return {
        //搜索栏
        filterData: [
          {
            name: "accountNo",
            type: "input",
            value: undefined,
            label: "请输入会员编号",
            placeholder:"会员编号：",
          }, {
            name: "custName",
            type: "input",
            value: undefined,
            label: "请输入客户姓名",
            placeholder:"客户姓名：",
          },
        ],
        relevanceBatch_grid: {
          height: "calc(100vh - 250px)",
          width: 0, // 宽度
          row: [],
          field: [
            {
              title: "序号",
              align: "center",
              width: 50,
              dataIndex: "index",
              ellipsis: true,
              scopedSlots: {
                customRender: "index",
              },
            },
            {
              title: "会员编号",
              align: "center",
              width: 130,
              dataIndex: "accountNo",
              ellipsis: true,
            },
            {
              title: "客户姓名",
              align: "center",
              width: 160,
              dataIndex: "accountName",
              ellipsis: true,
            },
            {
              title: "身份证号",
              colSpan: 1,
              width: 100,
              dataIndex: "idCard",
              align: "center",
              ellipsis: true,
              scopedSlots: {
                customRender:"authStatus",
              }
            },
            {
              title: "联系方式",
              colSpan: 1,
              align: "center",
              width: 100,
              ellipsis: true,
              dataIndex: "phoneNo",
            },
            {
              title: "所属企业",
              colSpan: 1,
              align: "center",
              width: 140,
              ellipsis: true,
              dataIndex: "comName",
            },
            {
              title: "病例档案",
              colSpan: 1,
              align: "center",
              width: 120,
              ellipsis: true,
              dataIndex: "rechargeAmount",
              scopedSlots: {
                customRender: "rechargeAmount",
              },
            },
            {
              title: "注册日期",
              colSpan: 1,
              align: "center",
              width: 120,
              ellipsis: true,
              dataIndex: "regDate",
            },
            {
              title: "操作",
              width: 120,
              align: "center",
              scopedSlots: {
                customRender: "operation",
              },
            },
          ]
        },
        pageParam: {
          pageNum: 1,
          pageSize: 10,
          orderBy: ""
        },
        pageSizeOptions: ["10", "20", "50", "100"],
        total: 0,
        paramsObj: {
          accountNo: null,
          custName: null,
          recStatus:undefined
        },
        list: [],
        //添加弹窗
        addVisible: false,
        addTitle:"",
        addData:{},
        //查询加载
        tableLoading:false,
        memberId: "",
        //导入弹窗
        excelVisible: false,
        excelTitle:'',
      };
    },
    mounted() {
      // 获取字典
      DictionaryService.getAllNeedDic(["REC_STATUS"]).then((res) => {
        //查询
        this.queryList();
      }); 
      this.relevanceBatch_grid.width = 0;
      this.relevanceBatch_grid.field.map(item => {
        this.relevanceBatch_grid.width += item.width;
      });
    },
    methods: {
      paginationChange(page, pageSize) {
        this.pageParam.pageNum = page;
        this.queryList();
      },
      onShowSizeChange(current, size) {
        this.pageParam.pageSize = size;
        this.pageParam.pageNum = 1;
        this.queryList();
      },
      // 查询
      handle_seach(params) {
        this.paramsObj = params;
        this.pageParam.pageNum = 1;
        this.queryList();
      },
      queryList() {
        this.tableLoading = true;
        queryMemberList({
          pageParam: {
            pageNum: this.pageParam.pageNum,
            pageSize: this.pageParam.pageSize,
            orderBy: ""
          },
          content: this.paramsObj
        })
        .then((res) => {
          if (res.content.rows && res.content.rows.length) {
            this.relevanceBatch_grid.row = res.content.rows;
            this.total = res.content.page.totalRows;
          } else {
            this.relevanceBatch_grid.row = [];
            this.total = 0;
          }
          this.tableLoading = false;
        }, (err) => {
          this.tableLoading = false;
        });
      },
      //添加
      handle_add() {
        this.addVisible = true;
        this.addTitle = "添加会员信息";
      },
      //批量导入
      handle_upload() {
        this.excelVisible = true;
        this.excelTitle = "批量导入";
      },
      //删除
      handle_detele(data) {
        this.$confirm({
          title: "确定是否删除?",
          okText: "是",
          cancelText: "否",
          cancelType:"primary",
          onOk: () => {
            deleteMember({
              id: data
            }).then(res => {
              this.$message.success("操作成功！");
              //删除之后跳转到第一页
              this.pageParam.pageNum = 1;
              this.queryList();
            });
          },
          onCancel: () => {},
        });
      },
      //编辑
      handle_update(data) {
        queryMemberInfo({ id: data.id }).then(res => {
          this.addVisible = true;
          this.addTitle = "编辑会员信息";
          this.addData = res.content;
          this.memberId= data.id;
        }); 
      },
      //弹窗关闭
      close() {
        this.addVisible = false;
        this.excelVisible = false;
      },
      //添加弹窗确认
      addlHandleOk(data) {
        if (this.addTitle == "添加会员信息") {
          addMember(data).then(res => {
            this.$message.success("新增成功！");
            this.addVisible = false;
            this.queryList();
          }); 
        } else {
          undateMember(data).then(res => {
            this.$message.success("修改成功！");
            this.addVisible = false;
            this.queryList();
          }); 
        }
      },
      //查看
      look(data){
        this.$router.push({ path: '/home/customer-management/member/pages/remind-details',query: {accountNo:data.accountNo,custId:data.custId}});
      },
      //导入弹窗确认
      excelHandleOk() {
        this.excelVisible = false;
        this.queryList();
      }
    },
  };
  </script>
  
  <style scoped lang="less">
  .select_width {
    width: 180px !important;
  }
  .ellipsis {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .investment_flex {
    display: flex;
    margin-bottom: 15px;
  }
  .investment_li {
    margin-right: 15px;
  }
  .custom {
    margin: 5px;
    color: #4093e1;
    cursor: pointer;
  }
  .table_pagination {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .box_warp {
    overflow-y: auto;
  }
  .end {
    justify-content: flex-end;
  }
  .sp_name {
    display: inline-block;
    font-size: 20px;
    margin: 10px 0px;
    margin-bottom: 20px;
    padding: 0 5px;
    border-left: 5px solid #0b2464;
  }
  
  .table_bottom{
  
    .bottom_btn{
      margin-top: 10px;
  
      .btn_first{
        margin-right: 10px;
      }
    }
  }
  </style>